import { render, staticRenderFns } from "./SafetyFactors.vue?vue&type=template&id=597d4a76"
import script from "./SafetyFactors.vue?vue&type=script&lang=js"
export * from "./SafetyFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports